import ModalV2 from '@/components/ModalV2.jsx';
import { setModalState } from '@/redux/actions/uiActions/modalActions.js';
import memoizeSelector from '@/redux/lib/memoizeSelector';
import { modal } from '@/redux/selectors/uiSelectors';
import { useSelector } from 'react-redux';
import CustomArgumentsModalWrapper from './customArgumentsModal/CustomArgumentsModalWrapper.jsx';

const CustomArgumentsModal = () => {
  const modalState = useSelector(memoizeSelector('modal:customArguments', (state) => modal(state, 'customArguments')));
  const { open: show, isLookup } = modalState || {};
  const subtitle = isLookup ? 'Select all the custom fields you need. You can assign values after adding them.' : 'Write your custom field key and press Enter to add. You can assign values after adding them.';

  const handleClose = () => {
    setModalState('customArguments', { open: false });
  };

  // I put all the content of this modal in a wrapper so we're able to use getLookupMethod without causing an app level crash because of the conditional hook call.

  return (
    <ModalV2 //
      portal={true}
      maxWidth={'450px'}
      className={'custom-arguments-modal'}
      show={show}
      onHide={handleClose}
      useHeader={false}
      title={'Add Custom Fields'}
      description={subtitle}
      autoFocusRef={'.comp-input input'}>
      <CustomArgumentsModalWrapper />
    </ModalV2>
  );
};

export default CustomArgumentsModal;
